'use client';
import Grid from '@mui/material/Grid';
import useMediaQuery from '@mui/material/useMediaQuery';
import Section from '@repo/ui/src/components/Section';
import { AlignH } from '@repo/ui/src/types/general';
import { ToutContent } from '@repo/ui/src/components/ToutContent/_toutContent';
import { TitledSplitToutContentContainer } from './styles';

interface Props {
  darkMode: boolean;
  useTexture: boolean;
  heading: string;
  headerVariation: any;
  headerAlign: AlignH;
  leftColumn: string;
  leftColumnAlign: AlignH;
  rightColumn: string;
  rightColumnAlign: AlignH;
  className?: string;
}

export const TitledSplitToutContent = ({
  darkMode,
  useTexture,
  heading,
  headerVariation,
  headerAlign,
  leftColumn,
  leftColumnAlign,
  rightColumn,
  rightColumnAlign,
  className,
}: Props) => {
  const smAndDown = useMediaQuery((theme: any) => theme.breakpoints.down('md'));
  const computedHeaderAlign = smAndDown ? 'left' : headerAlign || 'center';

  return (
    <TitledSplitToutContentContainer className={className}>
      <Section dark={darkMode} texture={useTexture} gutterX basePadding gutterY>
        <Grid container className="divider dividerBottom">
          <Grid item xs={12} className="divider dividerTop" />
          <Grid item md={2} />
          <Grid item xs={12} md={8} className="heading">
            <ToutContent
              dark={darkMode}
              heading={heading}
              headerVariation={headerVariation || 'h2'}
              headingStyleVariant="h1"
              align={computedHeaderAlign}
            />
          </Grid>
          <Grid item md={2} />
          <Grid item md={2} />
          <Grid item xs={12} md={4} className="leftColumn">
            <ToutContent
              dark={darkMode}
              headingLight={leftColumn}
              headingStyleVariant="h3"
              align={leftColumnAlign || 'left'}
              fullWidth
            />
          </Grid>
          <Grid item xs={12} md={4} className="rightColumn">
            <ToutContent
              dark={darkMode}
              description={rightColumn}
              align={rightColumnAlign || 'left'}
              fullWidth
            />
          </Grid>
          <Grid item md={2} />
        </Grid>
      </Section>
    </TitledSplitToutContentContainer>
  );
};

export default TitledSplitToutContent;
